module.exports = __webpack_public_path__ + "img/gal_14.033bdd41.png";